import { gql } from '@apollo/client';

export const DELETE_USER = gql`
  mutation updateUserStatus($userIds: [Int]!, $projectId: String!, $newUserStatus: EUserStatus!) {
    user {
      updateUsersStatus(userIds: $userIds, projectId: $projectId, newUserStatus: $newUserStatus)
    }
  }
`;
